import gsap from "gsap";
import './common'

var tl_main = gsap.timeline()
    .from('.p-sec1__tit--L', .5, {ease:'Power4.easeout', autoAlpha:0, 'width':0, delay: 0.5})
    .from('.p-sec1__tit--R', .65, {ease:'Power4.easeout', autoAlpha:0, 'width':0},'-=.25')
    .from('.p-sec1__p--1', .95, {autoAlpha:0, width:0},'-=.4')
    .from('.p-sec1__p--2', .75, {autoAlpha:0, width:0},'-=.3')
    .from('.p-sec1__link', .6, {autoAlpha:0, y:10},'-=.3')
    .from('.p-sec1__btn--scroll', .6, {autoAlpha:0, y:10},'-=.3')

promokit.video({
    el: '#player-bg',
    url: 'https://vod.plaync.com/BS/update/210512/preorder_index_bg_pc.mp4',
    loop: true,
    autoplay: true,
    mute: true,
    preload: true,
    resizeTarget: 'window'
});

promokit.preload({
    complete: function() {
        tl_main.seek(0);
    }
});

var currentTop, delta, section2Top, section3Top;
var flag = false;

$( window ).resize( function(){
    section2Top = $('#section-2').offset().top;
    section3Top = $('#section-3').offset().top;
});

var goSection = function(_sectionTop){
    if(!flag){
        flag = true;
        $("html,body").stop().animate({
            scrollTop: _sectionTop + 'px',
        }, {
            duration: 700,
            complete: function () {
                flag = false;
            }
        });
    }
};

$('#container').on('scroll touchmove mousewheel DOMMouseScroll', function(event) {
    currentTop = $(window).scrollTop();
    var E = event.originalEvent;
    delta = 0;
    if (E.detail)
        delta = E.detail * -40;
    else
        delta = E.wheelDelta;

    if(!flag){
        if(delta < 0 && (currentTop < section2Top/2)){
            // 마우스 휠을 아래로 내렸을 경우
            flag = true;
            $("html,body").stop().animate({
                scrollTop: section2Top + 'px'
            }, {
                duration: 700,
                complete: function () {
                    flag = false;
                }
            });
        }
    }
    else{
        event.preventDefault();
        event.stopPropagation();
        return false;
    }
});

$('.p-sec1__btn--scroll').on('click',function () {
    goSection(section2Top);
});

$('.p-sec1__link-item--preorder, .p-sec2__link--preorder').on('click',function () {
    goSection(section3Top);
});

$('.p-form__num--certi input[type="number"]')[0].placeholder = '인증 번호 입력';

let page = promokit.page({
    el:'#container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton:{
        cookie:{
            type:'year',
            key:'INDEX_WEB_VISIT_210512_beginning',
            value:false
        },
        home:true,
        event:false,
        update:false,
        sns:true,
        theme:'black'
    },
    caution:{
        template:
            `<ol>
            <li>제재계정 및 테스트 서버는 참여가 불가능합니다.​</li>
            <li>보상 아이템은 모두 거래 불가 아이템입니다.​</li>
            <li>이벤트 일정이나 보상은 이벤트 진행 중 변경될 수 있으며, 비정상적인 참여가 확인되는 경우 해당 보상은 회수 및 취소될 수 있습니다.</li>
        </ol>`
    },
    remote: {
        title: 'MAIN',
        home: false,
        coupon: false,
        nshop: false,
        active:true,
        template: `<ul>
                  <li><a href="#section-2">한 눈에 보기</a></li>
                  <li><a href="#section-3">사전 예약 이벤트</a></li>
                  <li><a href="#section-4">카카오톡<br>채널 추가 이벤트</a></li>
                  <li><a href="#section-5">MEDIA</a></li>
                </ul>`
    },
});

$(window).on('load',function () {
    if($('.p-form-wrap').hasClass('p-mycoupon'))
        $('.p-sec2__link--preorder').addClass('preorder-end');
});



// WEBPACK FOOTER //
// ./src/js/index.js